import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'InboxesAdmin',
  properties: {},

  statics: {
    breadcrumb: 'Inboxes',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/inboxes_admin.js